import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-25/task-01";

const task: Slide = {
  titleHtml:
    "Order the three displayed cases in ascending order of sound level difference</br>D (“sound insulation”) between the source room (room 1) and the receiving room</br>(room 2). The construction of the separating wall is always the same.",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
